import css from 'styled-jsx/css';

export default css`.comp-info{
    display: flex;
    align-items: center;
    margin-bottom: 7px;
    padding: 0 16px;
    cursor: pointer;
    .logo-compName{
      padding-right: 17px;
      position: relative;
      &::before{
        position: absolute;
        content: ' ';
        width: 1px;
        height: 12px;
        background: #E6EAF1;
        top: 50%;
        transform: translateY(-50%);
        right: 8.5px;
      }
      img{
        border-radius: 5px;
        width: 22px;
        height: 22px;
      }
      span{
        font-size: 12px;
        font-weight: 500;
        color: #07132B;
        line-height: 17px;
        margin-left: 8px;
        vertical-align: middle;
      }
    }
    .comp-tags{
      font-size: 12px;
      font-weight: 400;
      color: #617185;
      line-height: 21px;
      label{
        margin-right: 15px;
      }
    }
  }`